import { render, staticRenderFns } from "./MuvekkilList.vue?vue&type=template&id=4a42772f"
import script from "./MuvekkilList.vue?vue&type=script&lang=ts"
export * from "./MuvekkilList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports